import PropTypes from 'prop-types';
import React from 'react';

const TicketTypeInventoryStats = ({ item, className }) => {
  return (
    <div className={className || "small text-muted text-nowrap mt-1"}>
      {item.sellable_count !== undefined ? (
        <span>
          {item.sold_count} sold {item.held_count} held {item.reserved_count} reserved {item.sellable_count} sellable
        </span>
      ) : (
        <div
          style={{
            width: '200px',
            height: '14px',
            backgroundColor: 'var(--od-c-e9ecef, #e9ecef)',
            borderRadius: '4px'
          }}
        />
      )}
    </div>
  );
};

TicketTypeInventoryStats.propTypes = {
  item: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default TicketTypeInventoryStats;

